export function roundToPreviousHour(date) {
  const newDate = new Date(date);
  newDate.setHours(newDate.getHours(), 0, 0, 0);
  return newDate;
}
